import {Save,Obtener,Editar} from '@/Generico/Conexion';
import ResponseGenerico from '@/entidades/ResponseGenerico';
import { mainAxios } from '@/plugins/axios';


class Mesa 
{
    id?: number;
    plantaId?: number;
    plantaName?: string;
    descripcion?: string;
    estado?: boolean;

    constructor(_id?:number,_plantaId?:number,_plantaName?: string,_descripcion?: string,_estado?:boolean)
    {
        this.id = _id;
        this.plantaId = _plantaId;
        this.plantaName = _plantaName;
        this.descripcion  =_descripcion;
        this.estado = _estado;
    }
}

async function  GuardarMesa(mesa:Mesa):Promise<ResponseGenerico>
{
    return await Save<Mesa>("mesa/Guardar",mesa,mainAxios);
} 

async function  EditarMesa(mesa:Mesa):Promise<ResponseGenerico>
{
    return await Editar<Mesa>("mesa/Actualizar",mesa,mainAxios);
} 

async function  EditarEstadoMesa(mesa:Mesa):Promise<ResponseGenerico>
{
    return await Editar<Mesa>("mesa/CambiarEstado",mesa,mainAxios);
} 

async function ObtenerMesa()
{
    return await Obtener<Mesa>("mesa/Obtener",mainAxios);
}


async function ObtenerSelectMesa()
{
    return await Obtener<Mesa>("mesa/ObtenerSelect",mainAxios);
}


async function ObtenerMesaSelect(plantaId:number)
{
    return Obtener<Mesa>(`mesa/obtenerselect/${plantaId}`,mainAxios);
}

export {
    Mesa,
    GuardarMesa,
    EditarMesa,
    EditarEstadoMesa,
    ObtenerMesa,
    ObtenerSelectMesa,
    ObtenerMesaSelect
}